var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArtistManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0137 14.5H15.4222C16.3804 14.5 17.1426 14.0634 17.8269 13.453C19.5654 11.9022 15.4788 10.3333 14.0837 10.3333M12.417 2.05731C12.6062 2.01977 12.8027 2 13.0043 2C14.5209 2 15.7503 3.11929 15.7503 4.5C15.7503 5.88071 14.5209 7 13.0043 7C12.8027 7 12.6062 6.98023 12.417 6.94269",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.23443 11.2593C2.25195 11.7858 -0.324052 12.8609 1.2449 14.2062C2.01133 14.8633 2.86492 15.3333 3.9381 15.3333H10.0619C11.1351 15.3333 11.9887 14.8633 12.7551 14.2062C14.3241 12.8609 11.7481 11.7858 10.7656 11.2593C8.46167 10.0247 5.53832 10.0247 3.23443 11.2593Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 4.08333C10.3333 5.92428 8.84095 7.41667 7 7.41667C5.15905 7.41667 3.66667 5.92428 3.66667 4.08333C3.66667 2.24238 5.15905 0.75 7 0.75C8.84095 0.75 10.3333 2.24238 10.3333 4.08333Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArtistManagement);
export default __webpack_public_path__ + "static/media/icon-artist-management.57955d374e5aab157b1c192cb3c44c66.svg";
export { ForwardRef as ReactComponent };